// React router base path
export const ROUTER_BASE_PATH = '/m/accounts'
export const AR_ROUTER_BASE_PATH = '/ar/m/accounts'
export const DESKTOP_ROUTER_BASE_PATH = '/accounts'
export const AR_DESKTOP_ROUTER_BASE_PATH = '/ar/accounts'

export const LOAD_HOME = '/'
export const LOAD_TRIP_DETAILS = '/trips/:tripId'
export const LOAD_CANCELLATION = '/trips/:tripId/cancel'
export const LOAD_EXPRESSWAY = '/expressway'
export const LOAD_WALLET = '/wallet'
export const LOAD_TERMS = '/terms'
export const LOAD_PRIVACY = '/privacy'
export const LOAD_TRIP_LIST = '/trips'
export const LOAD_SUPPORT = '/trips/support'

export const TRIP_MOBILE_TOOLS_BASE_PATH = 'm/accounts/trips/'
function isFlyin() {
    return window.location.hostname.includes('flyin')
  }
// Trip tools section
export const TRIP_TOOLS_BASE_PATH = '/account/trips/'
export const CANCELLATION_LINK = '/cancel'
export const RESCHEDULE_LINK = '/reschedule/intro'
export const SUPPORT_LINK = '/html/support-widget.shtml?isTripDetailsPage='
export const ADD_TO_PASSBOOK_LINK = '/pkpass?flight_id='

// Link to redirect to external webviews, when running locally
export const LOCAL_REDIRECT_LINK = 'https://qa2.cleartrip.com'

// Link for static image
export const FLIGHT_ICON_PATH = 'https://qaui.cltp.co/images/air_logos/'

// Account and Trips Links
export const SETTINGS_LINK = '/m/settings'

// Login Logout links
export const LOGOUT_LINK = '/signout'
export const LOGIN_LINK = '/m/signin?service='

// Non air trips redirection link
export const NON_AIR_REDIRECT_LINK = '/m/trips/'
export const TRIP_NOT_FOUND = '/trip_not_found'

export const AIR_LOGOS_PATH = 'https://qaui.cltp.co/images/air_logos/'

// Redirection for unauthorized request
export const UNAUTHORIZED_REDIRECT = isFlyin() ? LOAD_HOME : '/support'
// export const UNAUTHORIZED_REDIRECT_PWA = '/m/accounts/trips'

export const WALLET_PWA_PATH = '/accounts/wallet'
export const WALLET_DESKTOP_PATH = '/accounts/wallet'
